module.exports = __webpack_public_path__ + "static/img/banner06.2f3571ef.png";